import { render, staticRenderFns } from "./AccessNameAddress.vue?vue&type=template&id=1dedc15f"
import script from "./AccessNameAddress.vue?vue&type=script&lang=js"
export * from "./AccessNameAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports